import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useAsyncCallback } from '../../../../../hooks'
import { getRelatedRequestsTotalCount } from '../../RequestProfileTabAttachedRequests.api'

export function useRelatedRequestsCounters({ requestId }) {
  const [counters, setCounters] = useState(EMPTY_OBJECT)

  const handleLoadCounters = useAsyncCallback(() => {
    return getRelatedRequestsTotalCount({ requestId })
      .then(response => {
        setCounters(response?.data || EMPTY_OBJECT)

        return response
      })
      .catch(() => {
        setCounters(EMPTY_OBJECT)

        return null
      })
  }, [requestId])

  useEffect(() => {
    if (requestId) {
      handleLoadCounters()
    }
  }, [requestId])

  return { counters, handleLoadCounters }
}
